var ProfileQuestionnaireStatus = /* @__PURE__ */ ((ProfileQuestionnaireStatus2) => {
  ProfileQuestionnaireStatus2["ToComplete"] = "to-complete";
  ProfileQuestionnaireStatus2["Completing"] = "completing";
  ProfileQuestionnaireStatus2["Completed"] = "completed";
  return ProfileQuestionnaireStatus2;
})(ProfileQuestionnaireStatus || {});
export {
  ProfileQuestionnaireStatus
};
//# sourceMappingURL=profile-questionnaire-status.enum.es.js.map
